import { hasLocalStorage } from 'services/featureFlags';

export const marktoolsToggleOpenLocalStorage = isOpen => {
  if (hasLocalStorage()) {
    localStorage.setItem('toolsToggleOpen', isOpen);
  }
};
export const isToolsToggleOpenLocalStorage = () =>
  localStorage.getItem('toolsToggleOpen') === 'true';
